// extracted by mini-css-extract-plugin
module.exports = {"bottomButton":"SerialNumberForm_bottomButton__3HRQe","serialNumberForm":"SerialNumberForm_serialNumberForm__2H--9","barcodeInput":"SerialNumberForm_barcodeInput__1DgDz"};